export const siteConfig = {
    name: 'AITechCare',
    legalName: 'AITECHCARE, S.L.',
    taxId: 'B93979599',
    registeredAddress: 'Calle Alejandro Dumas, 17, oficinas, 29004 Málaga, España',
    email: 'support@aitechcare.net',
    legalEmail: 'support@aitechcare.net',
    privacyEmail: 'support@aitechcare.net',
    refundsEmail: 'support@aitechcare.net',
    phone: '',
    supportUrl: '',
    legalOwner: 'AITECHCARE, S.L.',
    domain: 'https://aitechcare.net',
    activity: 'Actividades de consultoría informática y gestión de instalaciones informáticas',
    dataProtectionAuthority: {
        name: 'Agencia Española de Protección de Datos (AEPD)',
        url: 'https://www.aepd.es/',
        address: 'C/ Jorge Juan, 6, 28001 Madrid, España'
    },
    defaultLocale: 'es'
};
export const legalDocumentVersion = '2026-09-27';
